(function ($)
{
    $.widget("ui.BuildingBlock",
    {
        options:
        {
            PageContentId: null,
            BuildingSelector: '.building',
            BuildingInfoUrl: "/Core/Buildings/Block/",
            BuildingInfoLoadingTitle: 'Loading School Details',
            BuildingInfoSuccessTitle: 'School Details',
            BuildingInfoErrorTitle: 'Error Loading School Details',
            BuildingInfoLoadingContent: 'Loading School Details.',
            BuildingInfoErrorContent: 'Error loading School Details.'
        },

        ContentId: null,
        
        _destroy: function ()
        {
        },

        _init: function ()
        {
        },

        _create: function ()
        {
            var self = this;
            var jElement = $(self.element);
            
            self.ContentId = self.options.PageContentId;
            
            jElement.on(
                'click',
                self.options.BuildingSelector + "[data-building-url]," + self.options.BuildingSelector + "[data-building-id]",
                function(aEvent)
                {
                    var lBuilding = $(aEvent.target).parents('.building');
                    if (lBuilding.length != 1)
                    {
                        return false;
                    }
                    var lNewPageUrl = lBuilding.data('building-url');
                    var lBuildingId = lBuilding.data('building-id');
                    if (!FBUtilities.IsParameterUndefinedOrNull(lBuildingId))
                    {
                        self.SelectBuilding(lBuildingId, aEvent.target);
                        return false;
                    }
                    if (!FBUtilities.IsStringEmptyOrWhitespace(lNewPageUrl))
                    {
                        window.location.href = lNewPageUrl;
                    }
                    return false;
                }
            );
            
            self._InitClickSelectorElements();
        },
        
        _InitClickSelectorElements: function()
        {
            var self = this;
            var jElement = $(self.element);
        
            var lSelectElements = jElement.find(self.options.BuildingSelector + "[data-building-url]," + self.options.BuildingSelector + "[data-building-id]");
            lSelectElements.css('cursor','pointer');
        },

        SelectBuilding: function (aBuildingId, aSelectionElement)
        {
            var self = this;
            if (FBUtilities.IsStringEmptyOrWhitespace(self.options.BuildingInfoUrl))
            {
                return;
            }

            new FBAjaxDialog().Start({
                AjaxUrl: `${self.options.BuildingInfoUrl}${aBuildingId}`
                , Data: {ParentContentId: self.options.PageContentId}
                , ExtraDialogClasses: 'fbd_building'
                , LoadingDialogTitle: self.options.BuildingInfoLoadingTitle
                , SuccessDialogTitle: self.options.BuildingInfoSuccessTitle
                , ErrorDialogTitle: self.options.BuildingInfoErrorTitle
                , LoadingContent: self.options.BuildingInfoLoadingContent
                , ErrorContent: self.options.BuildingInfoErrorContent
                , SelectionElement: aSelectionElement
            }
            );
        }
    });
})(jQuery);
